import { ref as m, watch as c, onBeforeUnmount as f } from "vue";
var g = /* @__PURE__ */ ((t) => (t.PageLink = "editPageLink", t.Math = "editMath", t.ContentWriter = "editContentWriter", t.Callout = "editCallout", t.Embed = "editEmbed", t.Image = "editImage", t.Button = "editButton", t.Tab = "editTab", t.Details = "editDetails", t))(g || {}), C = /* @__PURE__ */ ((t) => (t.PageRename = "pageRename", t))(C || {});
const a = {
  emitExternalEvent: () => null,
  editNode: () => null
};
function h() {
  return {
    handleClick: () => a.emitExternalEvent(
      "pageRename"
      /* PageRename */
    )
  };
}
function k(t, e, l) {
  function i() {
    t.value && (e != null && e.editor.view.editable) && a.editNode(t.value, e, l);
  }
  const u = m(e == null ? void 0 : e.selected);
  return c(
    [() => e == null ? void 0 : e.selected, t],
    () => {
      e != null && e.selected ? i() : a.editNode(null, e, l), u.value = e == null ? void 0 : e.selected;
    },
    { immediate: !0 }
  ), f(() => {
    u.value && a.editNode(null, e, l);
  }), {
    handleClick: i
  };
}
export {
  C as ExternalEvent,
  g as NodeEditEvent,
  a as editEventHandlers,
  k as useExternalEditModal,
  h as usePageRenameModal
};
